const mergeMediaObjectsStyles = {
  selectionList: {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    maxHeight: "55vh",
    overflowY: "auto",
  },
  centeredContent: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    minHeight: "12rem",
  },
  orderedList: {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    marginBottom: 2,
  },
  dragHandle: {
    cursor: "grab",
    minWidth: "2.5rem",
  },
  actions: {
    width: { xs: "100%", md: "600px" },
  },
  confirmationList: {
    marginBottom: 0,
    marginTop: 1,
    maxHeight: "12rem",
    overflowY: "auto",
  },
};

export default mergeMediaObjectsStyles;
